// api.js
export const BASE_URL = 'https://eatura-demo4u.atg.first-colo.net';
